/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationEditCancelObservationViewModel } from "../types/CourseRegistrationEditCancelObservationViewModel.ts";

export const courseRegistrationEditCancelObservationViewModelSchema = z.object({
  courseRegistrationStatusId: z.optional(
    z
      .number()
      .int()
      .describe("ID do registro de status de matrícula a ser editado."),
  ),
  newObservation: z
    .string()
    .describe(
      "Novo texto da observação de cancelamento. Máximo de 250 caracteres.",
    )
    .nullish(),
}) as unknown as ToZod<CourseRegistrationEditCancelObservationViewModel>;
